module.exports = __webpack_public_path__ + "img/typing.7ecd6aec.gif";